import { ContractModel, ContractCategory } from "src/app/v2/pages/contracts/models/contracts.models";
import { MockScenario } from "../mock-scenario";

const folketrygdenContract: ContractModel = {
  id: "NAV-001",
  name: "Folketrygden",
  subtitle: "NAV ⋅ Offentlig pensjon",
  detailsLink: null,
  type: ContractCategory.Folketrygden,
  contractOptions: { isMoved: false, isPaidUp: true },
  totalBalance: null,
  totalReturn: null,
  inTransit: false,
};

export const generateMockContractsFromNav = (scenario: MockScenario): { payload: ContractModel[] } => {
  return {
    payload: scenario.navContracts ? [folketrygdenContract] : [],
  };
};
